<template>
  <div class="user">
  <van-nav-bar title="个人中心" left-arrow @click-left="goBack" />
  <van-cell-group>
    <van-cell title="我的订单" is-link to="/myorder" />
    <van-cell title="信息维护" is-link to="/address" />
  </van-cell-group>
  <van-button type="danger" block class="logout-btn" @click="handleLogout">退出登录</van-button>
  </div>
</template>

<script>
export default {
  name: 'UserIndex',
  methods: {
    goBack () {
      this.$router.push({ name: 'basicMap' })
    },
    handleLogout () {
      this.$dialog.confirm({
        title: '提示',
        message: '确定要退出登录吗？'
      }).then(() => {

      })
    }
  }
}
</script>

<style scoped>
.user {
  padding-top: 46px;
}
.van-cell-group{
  padding: 5%;
}
 .logout-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .van-cell__title{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/person.vue